import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core/lib/utils';
var FormStyle = function FormStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-form.ant-form{.ant-form-item-label{.anticon.anticon-question-circle-o{:hover{color:", ";}}}}"], primary6);
};
export default FormStyle;